import React from 'react';
import { CheckCircle2, Mail, Download, Moon } from 'lucide-react';
import { Footer } from '../components/Footer';
export function ThankYouPage() {
  return <div className="min-h-screen flex flex-col bg-cream font-sans text-dark selection:bg-gold/30 selection:text-forest-dark" data-id="element-614">
      <main className="flex-grow flex items-center justify-center py-16 px-4" data-id="element-615">
        <div className="max-w-3xl w-full mx-auto text-center" data-id="element-616">
          {/* Success Icon */}
          <div className="inline-flex items-center justify-center w-24 h-24 rounded-full bg-success/10 mb-8" data-id="element-617">
            <CheckCircle2 size={48} className="text-success" data-id="element-618" />
          </div>

          {/* Headlines */}
          <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-forest mb-6" data-id="element-619">
            ¡Felicidades! Tu Pedido Está Confirmado
          </h1>
          <p className="text-xl md:text-2xl text-dark/80 font-medium mb-12" data-id="element-620">
            Tu acceso completo ha sido enviado a tu correo electrónico.
          </p>

          {/* Next Steps Card */}
          <div className="bg-white rounded-2xl p-8 md:p-12 shadow-warm border border-gold/20 text-left mb-12 relative overflow-hidden" data-id="element-621">
            <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-forest via-gold to-forest" data-id="element-622"></div>

            <h2 className="font-serif text-2xl md:text-3xl font-bold text-forest mb-8 text-center" data-id="element-623">
              Tus Próximos Pasos:
            </h2>

            <div className="space-y-8" data-id="element-624">
              {/* Step 1 */}
              <div className="flex items-start gap-6" data-id="element-625">
                <div className="w-12 h-12 rounded-full bg-forest/10 flex items-center justify-center shrink-0" data-id="element-626">
                  <Mail size={24} className="text-forest" data-id="element-627" />
                </div>
                <div data-id="element-628">
                  <h3 className="text-xl font-bold text-dark mb-2" data-id="element-629">
                    1. Revisa tu bandeja de entrada
                  </h3>
                  <p className="text-dark/70 leading-relaxed" data-id="element-630">
                    Busca un correo de Hotmart con el asunto "Tu acceso a Cenas
                    Anti-Inflamatorias". Si no lo ves en 5 minutos, revisa tu
                    carpeta de spam o promociones.
                  </p>
                </div>
              </div>

              {/* Step 2 */}
              <div className="flex items-start gap-6" data-id="element-631">
                <div className="w-12 h-12 rounded-full bg-forest/10 flex items-center justify-center shrink-0" data-id="element-632">
                  <Download size={24} className="text-forest" data-id="element-633" />
                </div>
                <div data-id="element-634">
                  <h3 className="text-xl font-bold text-dark mb-2" data-id="element-635">
                    2. Descarga tu material
                  </h3>
                  <p className="text-dark/70 leading-relaxed" data-id="element-636">
                    Accede a la plataforma y descarga tu Guía Maestra, el
                    Recetario de 21 Cenas y todos tus bonos exclusivos.
                  </p>
                </div>
              </div>

              {/* Step 3 */}
              <div className="flex items-start gap-6" data-id="element-637">
                <div className="w-12 h-12 rounded-full bg-forest/10 flex items-center justify-center shrink-0" data-id="element-638">
                  <Moon size={24} className="text-forest" data-id="element-639" />
                </div>
                <div data-id="element-640">
                  <h3 className="text-xl font-bold text-dark mb-2" data-id="element-641">
                    3. Comienza esta misma noche
                  </h3>
                  <p className="text-dark/70 leading-relaxed" data-id="element-642">
                    Elige una receta rápida del recetario, aplica el Método de
                    Digestión en Reposo y prepárate para despertar diferente
                    mañana.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Support Section */}
          <div className="bg-forest/5 rounded-xl p-6 border border-forest/10" data-id="element-643">
            <p className="text-dark/80 font-medium" data-id="element-644">
              ¿Tienes algún problema con tu acceso?
            </p>
            <p className="text-dark/60 mt-2" data-id="element-645">
              Escríbenos a{' '}
              <a href="mailto:soporte@ejemplo.com" className="text-forest font-bold hover:underline" data-id="element-646">
                soporte@ejemplo.com
              </a>{' '}
              y te ayudaremos de inmediato.
            </p>
          </div>
        </div>
      </main>

      <Footer data-id="element-647" />
    </div>;
}